import {ReactNode} from "react";
import {Box, Colors, Container, Text} from "@bounce/shared/ui";

export const openInNewTab = (url: string) => window.open(url, "_blank", "noopener");

type Props = {children: ReactNode};

export const ResourcePanel = ({children}: Props) => (
  <Box
    sx={{
      width: "100%",
      alignSelf: "stretch",
      border: `1px solid ${Colors.tertiary._300}`,
      borderRadius: "10px",
      backgroundColor: Colors.tertiary._100,
      px: 2,
      py: 1.5,
      mb: 2,
    }}
  >
    <Container fullWidth sx={{gap: 1, alignItems: "flex-start"}}>
      {children}
    </Container>
  </Box>
);

export const ResourcePanelTitle = ({children, spaced}: {children: ReactNode; spaced?: boolean}) => (
  <Text size={13} variant="inter600" sx={{color: Colors.grey._900, ...(spaced && {mt: 1})}}>
    {children}
  </Text>
);

export const ResourcePanelNote = ({children}: {children: ReactNode}) => (
  <Text size={13} variant="inter400" sx={{color: Colors.grey._700, textAlign: "left"}}>
    {children}
  </Text>
);

export const note = (text: string) => <ResourcePanelNote>{text}</ResourcePanelNote>;
